// removed by extract-text-webpack-plugin
module.exports = {"forms":"c-LoginWrapper__forms","info":"c-LoginWrapper__info","text":"c-LoginWrapper__text"};